const updateURL = (params: any) => {
  window.history.pushState({}, '', `?${params.toString()}`);
};

const prepareValue = (value: any) => {
  const excludes = ['by_time_of_publication', 'all_types_trucks'];

  if (excludes.includes(value)) {
    return '';
  }

  return value;
};

const setUrlParam = ({ field, value }: { field: string; value: any }) => {
  const searchParams = new URLSearchParams(window.location.search);
  const fieldType: string = field?.replace('Value', '');

  if (value === '0') return;

  if (prepareValue(value)) {
    searchParams.set(fieldType, value);
    updateURL(searchParams);
  } else {
    searchParams.delete(fieldType);
    updateURL(searchParams);
  }
};

export default setUrlParam;
